import React from "react";
import styled from "styled-components";
import { Timeline_Brand_Update } from "./Timeline_Brand_Update";

const TimelineMerge = styled.div`
    display: grid;
    gap: 0.6rem;
`;

// Displays a merge as one compact previous-to-surviving identity change.
export const Timeline_Merge = (props) => {
    return (
        <TimelineMerge>
            <Timeline_Brand_Update event={props.event} t={props.t} />
        </TimelineMerge>
    );
};
